// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: 'Open Sans', sans-serif !important;
}

body{
  font-family: 'Open Sans', sans-serif;
}

  
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["* {\n  font-family: 'Open Sans', sans-serif !important;\n}\n\nbody{\n  font-family: 'Open Sans', sans-serif;\n}\n\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
